import React, { useEffect, useState } from 'react';
import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { propTypes } from '../../util/types';
import config from '../../config';
import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';



import { TopbarContainer } from '../../containers';
import { desktopDevice } from '../../util/userAgent'
import facebookImage from '../../assets/tourlyFacebook-1200x630.jpg';
import twitterImage from '../../assets/tourlyTwitter-600x314.jpg';
import css from './LandingPage.module.css';
import LandingpageContent from './LandingpageContent';

const LANDING_PAGE_CONTENT = {
  'HOME': {
    'showSectionKeyPoints': true,
    'showSectionDestinations': false,
    'showRecombeeRecommendations': true,
    'showSectionLocationCategory': true,
    'showSectionHowItWorks': true,
    'showBnbButton': false,
    'showSectionSAProgramSummary': false,
    'showSectionSAChart': false,
    'showSectionSATiers': false,
    'showSectionBnbsProgramSummary': false,
    'showSectionBnbsWorkingWith': false,
    'showSectionBnbsBook': false,
    'showSectionBnbsBookMobile': false,
    'showSectionBnbsFeaturedIn': false,
    'showSectionBnbsHelp': false
  },
  'SA': {
    'showSectionKeyPoints': false,
    'showSectionDestinations': false,
    'showRecombeeRecommendations': false,
    'showSectionLocationCategory': false,
    'showSectionHowItWorks': true,
    'showBnbButton': true,
    'showSectionSAProgramSummary': true,
    'showSectionSAChart': true,
    'showSectionSATiers': true,
    'showSectionBnbsProgramSummary': false,
    'showSectionBnbsWorkingWith': false,
    'showSectionBnbsBook': false,
    'showSectionBnbsBookMobile': false,
    'showSectionBnbsFeaturedIn': false,
    'showSectionBnbsHelp': false
  },
  'TO': {
    'showSectionKeyPoints': false,
    'showSectionDestinations': false,
    'showRecombeeRecommendations': false,
    'showSectionLocationCategory': true,
    'showSectionHowItWorks': true,
    'showBnbButton': false,
    'showSectionSAProgramSummary': false,
    'showSectionSAChart': false,
    'showSectionSATiers': false,
    'showSectionBnbsProgramSummary': false,
    'showSectionBnbsWorkingWith': false,
    'showSectionBnbsBook': false,
    'showSectionBnbsBookMobile': false,
    'showSectionBnbsFeaturedIn': false,
    'showSectionBnbsHelp': false
  },
  'BNB': {
    'showSectionKeyPoints': false,
    'showSectionDestinations': false,
    'showRecombeeRecommendations': false,
    'showSectionLocationCategory': false,
    'showSectionHowItWorks': false,
    'showshowBnbButton': false,
    'showSectionSAProgramSummary': false,
    'showSectionSAChart': false,
    'showSectionSATiers': false,
    'showSectionBnbsProgramSummary': true,
    'showSectionBnbsWorkingWith': true,
    'showSectionBnbsBook': true,
    'showSectionBnbsBookMobile': true,
    'showSectionBnbsFeaturedIn': true,
    'showSectionBnbsHelp': true
  }
}

const LandingPageFactory = (props) => {
  
  const { location } = props;
  const pathname = location.pathname
  
  switch (pathname) {
    case '/home':
      return  <LandingpageContent
                pageContent={LANDING_PAGE_CONTENT['HOME']}
                {...props}
              />;
    case '/tour-operators':
      return  <LandingpageContent
                pageContent={LANDING_PAGE_CONTENT['TO']}
                {...props}
              />;
    case '/affiliates':
      return  <LandingpageContent
                pageContent={LANDING_PAGE_CONTENT['SA']}
                {...props}
              />;
    case '/bnbs':
      return  <LandingpageContent
                pageContent={LANDING_PAGE_CONTENT['BNB']}
                {...props}
              />;
    default:
      break;
  }

};

export const LandingPageComponent = props => {
  const {
    history,
    intl,
    location,
    scrollingDisabled,
    currentUserListing,
    currentUserListingFetched,
  } = props;

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const siteTitle = config.siteTitle;

  const schemaFactory = () => {
    const pathname = location.pathname;

    switch (pathname) {
      case '/home':
        return {
          schemaTitle: intl.formatMessage({ id: 'LandingPage.schemaTitle' }, { siteTitle }),
          schemaDescription: intl.formatMessage({ id: 'LandingPage.schemaDescription' }),
        };
      case '/tour-operators':
        return {
          schemaTitle: intl.formatMessage({ id: 'LandingPageTO.schemaTitle' }, { siteTitle }),
          schemaDescription: intl.formatMessage({ id: 'LandingPageTO.schemaDescription' }),
        };
      case '/affiliates':
        return {
          schemaTitle: intl.formatMessage({ id: 'LandingPageSA.schemaTitle' }, { siteTitle }),
          schemaDescription: intl.formatMessage({ id: 'LandingPageSA.schemaDescription' }),
        };
      case '/bnbs':
        return {
          schemaTitle: intl.formatMessage({ id: 'LandingPageBnbs.schemaTitle' }, { siteTitle }),
          schemaDescription: intl.formatMessage({ id: 'LandingPageBnbs.schemaDescription' }),
        };
      default:
        return {
          schemaTitle: intl.formatMessage({ id: 'LandingPage.schemaTitle' }, { siteTitle }),
          schemaDescription: intl.formatMessage({ id: 'LandingPage.schemaDescription' }),
        };
    }
  };

  const landingPageSchema = schemaFactory();
  const schemaTitle = landingPageSchema.schemaTitle;
  const schemaDescription = landingPageSchema.schemaDescription;
  const schemaImage = `${config.canonicalRootURL}/${facebookImage}`;

  const [isDesktopDevice, setIsDesktopDevice] = useState(false);

  useEffect(() => {
    setIsDesktopDevice(desktopDevice())
  },[])

  //Recombee recomendations object
  const showRecomms= config.recombeeConfig.homePage

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[{ url: twitterImage, width: 600, height: 314 }]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="LandingPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <LandingPageFactory
           history={history}
           intl={intl}
           location={location}
           scrollingDisabled={scrollingDisabled}
           currentUserListing={currentUserListing}
           currentUserListingFetched={currentUserListingFetched}
           showRecomms={showRecomms}
          />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

LandingPageComponent.defaultProps = {
  currentUserListing: null,
  currentUserListingFetched: false,
};

LandingPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  currentUserListing: propTypes.ownListing,
  currentUserListingFetched: bool,

  // from withRouter
  history: object.isRequired,
  location: object.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUserListing, currentUserListingFetched } = state.user;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUserListing,
    currentUserListingFetched,
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(withRouter, connect(mapStateToProps), injectIntl)(LandingPageComponent);

export default LandingPage;
